import { render, staticRenderFns } from "./setVipTag.vue?vue&type=template&id=a539f39e&scoped=true&"
import script from "./setVipTag.vue?vue&type=script&lang=js&"
export * from "./setVipTag.vue?vue&type=script&lang=js&"
import style0 from "./setVipTag.vue?vue&type=style&index=0&id=a539f39e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a539f39e",
  null
  
)

export default component.exports